export default __webpack_public_path__ + "static/media/Camion6-t.366b710a.png";